import * as React from 'react';

function FloorplanIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M15.41 9.746h-5.402M15.411 11.947V3M10.115 16v3a2 2 0 002 2H19a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h1.3'
				stroke='#545454'
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default FloorplanIcon;
